/**
 * server side 에서 정의된 후불결제 유저 가입상태 값 (apigw에 동일타입 존재
 */
export const PayLaterMemberRegisterStatus = {
    /** 정상 */
    NORMAL: 'NORMAL',
    /** 대기 */
    WAITING: 'WAITING',
    /** 거부 */
    DENIED: 'DENIED',
    /** 이용정지 */
    SUSPENDED: 'SUSPENDED',
    /** 연체 */
    OVERDUE: 'OVERDUE',
    /** 해지 */
    LEFT: 'LEFT',
}

export type PayLaterMemberRegisterStatusType = Constant<typeof PayLaterMemberRegisterStatus>

/**
 * 논의내용 참고
 * @see https://oss.fin.navercorp.com/Product-Planning/Paymoney_Paylater_Plan/issues/521#issuecomment-1570979
 */
export const TradeableStatus = {
    /** 거래가능 */
    NORMAL: 'NORMAL',
    /** 사용자 정상상태 아님으로 거래불가 */
    ABNORMAL_USER_STATUS: 'ABNORMAL_USER_STATUS',
    /** 거래가능시간 아니라 거래불가 */
    SYSTEM_CHECK: 'SYSTEM_CHECK',
    /** 허용된 납부일 아니라 거래불가 */
    UNCHANGED_PAYDUE: 'UNCHANGED_PAYDUE',
    /** 한도 부족으로 거래불가 */
    EXCEED_CREDIT_LIMIT_AMOUNT: 'EXCEED_CREDIT_LIMIT_AMOUNT',
    /** 그 외의 상태로 거래불가 */
    UNKNOWN: 'UNKNOWN',
} as const

export type TradeableStatusType = Constant<typeof TradeableStatus>

export const PayLaterUserStatus = {
    /** 정상 */
    NORMAL: 'NORMAL',
    /** 대기 */
    WAITING: 'WAITING',
    /** 거부 */
    DENIED: 'DENIED',
    /** 이용정지 */
    SUSPENDED: 'SUSPENDED',
    /** 연체 */
    OVERDUE: 'OVERDUE',
    /** 해지 */
    LEFT: 'LEFT',
}

export type PayLaterUserStatusType = Constant<typeof PayLaterUserStatus>

/**
 * 상수 참고
 * @see https://wiki.fin.navercorp.com/pages/viewpage.action?pageId=73597783
 */
export const UserInfoChangeFail = {
    /** 60일 이전에 재변경 불가능 (60일 조건은 변동 가능) */
    PAYDUE_ALREADY_REQUESTED: 'PAYDUE_ALREADY_REQUESTED',
    /** 매일 00시 ~ 07시 (청구서 작업시간) 변경불가능 (시간은 변동 가능) */
    PAYDUE_INVALID_TIME: 'PAYDUE_INVALID_TIME',
    /** 연체, 이용정지 등 상태의 사용자는 변경 불가능 */
    PAYDUE_INVALID_USER_STATUS: 'PAYDUE_INVALID_USER_STATUS',
    /** 하루 최대 변경 가능횟수 (5일 조건은 변동 가능) */
    PAYDUE_TOO_MANY_REQUEST_DAILY: 'PAYDUE_TOO_MANY_REQUEST_DAILY',
    /** 같은 납부일로 변경 시도 */
    PAYDUE_CANNOT_REQUEST_SAME_PAYDUE: 'PAYDUE_CANNOT_REQUEST_SAME_PAYDUE',
    /** 납부일을 15일을 제외한 다른날로 변경 시도 */
    PAYDUE_INVALID_VALUE: 'PAYDUE_INVALID_VALUE',
    /** 페이회원 API 실패 */
    EMAIL_CHANGE_FAILED: 'EMAIL_CHANGE_FAILED',
    /** 사용자 페이회원에 등록된 계좌 미존재 */
    ACCOUNT_INVALID_ACCKEY: 'ACCOUNT_INVALID_ACCKEY',
    /** 변경 계좌와 기존 계좌가 같은 경우 */
    ACCOUNT_SAME_ACCKEY: 'ACCOUNT_SAME_ACCKEY',
    /** 납부, 연체 배치 작업 중일 경우 납부계좌 변경 불가능 */
    ACCOUNT_INVALID_TIME: 'ACCOUNT_INVALID_TIME',
    /** 계좌 API 실패 */
    ACCOUNT_EXTERNAL_API_ERROR: 'ACCOUNT_EXTERNAL_API_ERROR',
} as const

export type UserInfoChangeFailType = Constant<typeof UserInfoChangeFail>

export const PayDueChangeFailCase = {
    /** 매일 00시 ~ 07시 (청구서 작업시간) 변경불가능 (시간은 변동 가능) */
    INVALID_TIME: 'INVALID_TIME',
    /** 연체로 인해 사용자 납부일 변경 불가능 */
    OVERDUE: 'OVERDUE',
    /** 이용정지로 인해 사용자 납부일 변경 불가능 */
    SUSPEBNDED: 'SUSPEBNDED',
} as const

export type PayDueChangeFailCaseType = Constant<typeof PayDueChangeFailCase>

/**
 * 납부일 변경방식
 */
export const PayDueChange = {
    IMMEDIATE: 'IMMEDIATE',
    NEXT_MONTH: 'NEXT_MONTH',
} as const

export type PayDueChangeType = Constant<typeof PayDueChange>
